module.exports = __webpack_public_path__ + "static/media/felicity-jones.95f09254.jpg";